import Marquee from "react-fast-marquee";
import { BRANDS } from "@/data";

export default function BrandMarquee() {
  return (
    <section id="brands" className="border-y border-white/10 bg-ink py-10" data-testid="brand-marquee">
      <div className="mb-8 px-6 md:px-10">
        <span className="overline text-orange">Featuring top brands</span>
      </div>
      <Marquee speed={38} gradient gradientColor="#050505" gradientWidth={120} pauseOnHover>
        {BRANDS.map((b, i) => (
          <div key={i} className="mx-6 flex items-center gap-6">
            <span className="font-display text-2xl font-medium tracking-tight text-steel/70 transition-colors duration-300 hover:text-white md:text-3xl">
              {b}
            </span>
            <span className="text-orange">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
